import { render, staticRenderFns } from "./GroupStats.vue?vue&type=template&id=de17c0de&scoped=true&"
import script from "./GroupStats.vue?vue&type=script&lang=js&"
export * from "./GroupStats.vue?vue&type=script&lang=js&"
import style0 from "./GroupStats.vue?vue&type=style&index=0&id=de17c0de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de17c0de",
  null
  
)

export default component.exports